import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getRoles(data) {
    return request.get(`/${platform}/roles`, data)
}

export function deleteRoles(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/roles/${ids}`)
}

export function storeOrUpdateRole(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/roles/${data.id}` : `/${platform}/roles`;
    return request[method](url, data)
}
